<template>
	<div>
		<div class="calendario">
			<div class="calendario-header text-muted">
				{{month + ' - ' + year}}
				<span class="float-right">
					<a href="#" v-on:click.prevent="subtractMonth()" class="text-secondary">
            			<i class="fa fa-fw fa-chevron-left"></i>
            		</a>
            		<a href="#" v-on:click.prevent="addMonth()" class="text-secondary">
		            	<i class="fa fa-fw fa-chevron-right"></i>
	            	</a>
				</span>
			</div>
	        <div class="calendario-content">
	        	<div class="calendario-week align-items-start" v-for="days in weeks">
	        		<div v-bind:class="{'week-name-day':day.weekNumber==1, 'calendario-day':true}" v-for="(day, index) in days">
	        			<span v-if="day.weekNumber==1" class="calendario-name-day" v-tooltip="weekDay(index).descripcion">
		            		{{weekDay(index).abr}}
		            	</span>

		            	<a v-on:click.prevent="setDay(day.date)" href="#" v-bind:class="{'calendario-label-day':true, 'calendario-label-today':day.isToday, 'calendario-label-select':(day.date) ? day.date.format('YYYY/MM/DD')==dateSelect.format('YYYY/MM/DD') : false}">
		            		<span v-if="day.label">
		            			{{day.label}}
		            		</span>
		            		<span v-else>
		            			&nbsp;
		            		</span>
		            	</a>
		        	</div>
	        	</div>
	        </div>
	    </div>
	    <input type="hidden" name="blabla">
	</div>
</template>
<script>
	export default{
		props: ['value'],
		data(){
			return {
				nameDays: [
					{
						abr: 'L',
						descripcion: 'Lunes'
					}, 
					{
						abr: 'M',
						descripcion: 'Martes'
					}, 

					{
						abr: 'M',
						descripcion: 'Miércoles'
					}, 

					{
						abr: 'J',
						descripcion: 'Jueves'
					}, 

					{
						abr: 'V',
						descripcion: 'Viernes'
					},

					{
						abr: 'S',
						descripcion: 'Sábado'
					},

					{
						abr: 'D',
						descripcion: 'Domingo'
					}],
				today: moment(),
				dateContext: moment(),
				dateSelect: moment()
			};
		},

		watch: {
            /*value: function (value) {
                this.dateSelect = value;
                this.dateContext = value ? moment(value) : moment();
            },*/
        },

		computed:{
			year: function () {
		        return this.dateContext.format('Y');
		    },
		    month: function () {
		        return this.dateContext.format('MMMM');
		    },
		    monthNumber: function(){
		    	return this.dateContext.month();
		    },
		    weeks() {
			    const weeks = [];
			    let monthStarted = false, monthEnded = false;
			    let monthDay = 0;
			    // Cycle through each week of the month, up to 6 total
			    for (let w = 1; w <= 6 && !monthEnded; w++) {
			      // Cycle through each weekday
			      const week = [];
			      for (let d = 1; d <= 7; d++) {
			        // We need to know when to start counting actual month days
			        if (!monthStarted && d > this.firstDayOfMonth) {
			        	// Initialize day counter
			        	monthDay = 1;
			         	// ...and flag we're tracking actual month days
			         	monthStarted = true;
			       		// Still in the middle of the month (hasn't ended yet)
			        } else if (monthStarted && !monthEnded) {
			          // Increment the day counter
			          monthDay += 1;
			        }
			        // Append day info for the current week
			        // Note: this might or might not be an actual month day
			        //  We don't know how the UI wants to display various days,
			        //  so we'll supply all the data we can
			        week.push({
			          label: monthDay ? monthDay.toString() : '',
			          number: monthDay,
			          weekdayNumber: d,
			          weekNumber: w,
			          beforeMonth: !monthStarted,
			          afterMonth: monthEnded,
			          inMonth: monthStarted && !monthEnded,
			          isToday: monthDay == this.today.date() && this.monthNumber == this.today.month() && this.year == this.today.year(),
			          isFirstDay: monthDay === 1,
			          isLastDay: monthDay === this.daysInMonth,
			          date: monthDay ? this.getDate(monthDay) : '',
			        });

			        // Trigger end of month on the last day
			        if (monthStarted && !monthEnded && monthDay >= this.daysInMonth) {
			          monthDay = 0;
			          monthEnded = true;
			        }
			      }
			      // Append week info for the month
			      weeks.push(week);
			    }
			    return weeks;
			},
		    daysInMonth: function () {
		        return this.dateContext.daysInMonth();
		    },
		    currentDate: function () {
		        return this.dateContext.get('date');
		    },
		    firstDayOfMonth: function () {
		        var firstDay = moment(this.dateContext).subtract((this.currentDate - 1), 'days');
		        return firstDay.weekday();
		    },
		    initialDate: function () {
		        return this.today.get('date');
		    },
		    initialMonth: function () {
		        return this.today.format('MMMM');
		    },
		    initialYear: function () {
		        return this.today.format('Y');
		    },
		},

		methods: {
			addMonth: function () {
		        this.dateContext = moment(this.dateContext).add(1, 'month');
		    },
		    subtractMonth: function () {
		        this.dateContext = moment(this.dateContext).subtract(1, 'month');
		    },
		    weekDay: function(number){
		    	return this.nameDays[number];
		    },
		    setDay: function(date){
		    	this.dateSelect = date;
		    	this.$emit('input', date)
		    },
		    hoy: function(){
		    	this.dateContext = moment();
		    },
		    getDate: function(day){
		    	return moment().set({'year': this.year, 'month': this.monthNumber, 'date': day});
		    }
		}
	}
</script>
<style>
	.calendario-day{
		width: 14.28%;
		display: inline-block;
		text-align: center;
		font-size: 10px;
	}

	.calendario-label-day {
		color: #17202a;
		display: block;
		border-radius: 4px;
	}

	.calendario-label-day:hover {
		color: #17202a;
		background-color: #abb2b9;
	}

	.calendario-label-select{
		background-color: #abb2b9;
	}

	.calendario-label-today {
		background-color: #cb4335;
		color: #fff;
	}

	.calendario-name-day{
		display: block;
		font-weight: 700;
		color: #566573;
	}
</style>